export const formatUTCDate = (timestamp) => {
    const date = new Date(timestamp);
    const day = String(date.getUTCDate()).padStart(2, '0');
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const year = String(date.getUTCFullYear());
    return `${day}/${month}/${year}`;
};


export const replaceWithAsterisks = (str) => {
    // Create a regular expression to match any character (except line breaks)
    var regex = /./g;

    // Replace each character with an asterisk
    var result = str.replace(regex, '*');

    return result;
};

export const isValidateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
}

export const isValidPhoneNumber = (phoneNumber) => {
    const phoneRegex = /^\+\d{1,3}\d{3,14}$/;
    return phoneRegex.test(phoneNumber);
}

export const isValidPhoneNumberWithoutCode = (phoneNumber) => {
    const phoneRegex =  /^\d{10}$/;
    return phoneRegex.test(phoneNumber);
}